import * as React from 'react'

import { Box, Icon, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import TimePicker from 'modules/core/components/Inputs/TimePicker'
import i18n from 'modules/core/lib/i18n'

import useIsTimeFormat24H from 'modules/shift_management/hooks/useIsTimeFormat24H'
import type PlannedBreakForm from 'modules/shift_management/lib/forms/PlannedBreakForm'

import { ShiftConfigWithBreaksForm } from '../forms'
import BreakDisplay from './BreakDisplay'

export interface Props {
  form: ShiftConfigWithBreaksForm
  popover: React.ReactNode
  onDeleteBreak: (dayConfig: ShiftConfigWithBreaksForm, form: PlannedBreakForm) => void
}

const ShiftDisplay = ({ form, popover, onDeleteBreak }: Props) => {
  const { shiftConfig, breaks } = form
  const { isTimeFormat24H } = useIsTimeFormat24H()

  return (
    <>
      <Box
        borderRadius={{
          all: 'abs008',
        }}
        padding="s16"
        width="full"
        background="grey100"
        gap="s16"
      >
        <Box flexDirection="row" justifyContent="spaceBetween" alignItems="center">
          <Text.Normal weight="medium">
            {i18n.t('shift_management.default_shift.form_labels.shift')}
          </Text.Normal>
          {popover}
        </Box>

        <Box flexDirection="row" alignItems="center">
          <TimePicker
            field={shiftConfig.get('start_at')}
            isTimeFormat24H={isTimeFormat24H}
            isNotValid={!shiftConfig.isValid}
          />
          <Box paddingX="s8">-</Box>
          <TimePicker
            field={shiftConfig.get('end_at')}
            isTimeFormat24H={isTimeFormat24H}
            isNotValid={!shiftConfig.isValid}
          />
        </Box>
      </Box>

      {!!breaks.length && (
        <Box gap="s8">
          <Box flexDirection="row" justifyContent="center">
            <Icon.Small icon="chevron-down"></Icon.Small>
          </Box>
          {breaks.map((breakForm, i) => (
            <BreakDisplay key={i} form={form} breakForm={breakForm} onDeleteBreak={onDeleteBreak} />
          ))}
        </Box>
      )}
    </>
  )
}

export default observer(ShiftDisplay)
